import React,{useState,useEffect} from 'react';
import {Button,Divider, Fab,Accordion,AccordionDetails,AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HeaderAdmin from '../../Components/HeaderAdmin'
import useImagenesCarta from '../../Hooks/useImagenesCarta';
import usePrivilegios from '../../Hooks/usePrivilegios';
import GlobalStyles from "../../Theme/AppTheme";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import styled from "styled-components";
import ImagenCarta from '../../Components/Configuracion/ImagenCarta';
import realtimeDB, { storage } from '../../Utils/api';
import AddPopup from '../../Components/Configuracion/AddPopup';

import Cartas from '../../Components/Configuracion/Cartas';
import HorariosCarta from '../../Components/Configuracion/HorariosCarta';
import Whatsapp from "../../Components/Configuracion/Whatsapp"
import EditorFotos from '../../Components/Configuracion/EditorFotos';


import Popups from '../../Components/Admin/Popups';

const ImagenUIPreview=styled.img`
display:block;
width:25%;
margin:10px 0;`;


const ContainerSection= styled.div`
border-radius:10px;
box-shadow: 0 0 0.25em 0.25em rgba(0, 0, 0, 0.25);
padding:10px;
margin:10px 10%;`;

const Section = ({title,children}) =>
{
    return <ContainerSection>
        <h3>{title}</h3>
        {children}
    </ContainerSection>
}
 
const Configuracion = () => 
{
    usePrivilegios();

    useEffect(() => 
    {
        document.title="Baum Lanús - Configuración"
    }, []);


    return (
        <div>
            <HeaderAdmin title={"Configuración"}/>

                 <Section title="Whatsapp"> <Whatsapp/> </Section>   
                 
            <Section title="Carta HH"> 
                <Cartas firebaseId={"/HH"}/> 
                <HorariosCarta firebaseId={"/HH"}/>
            </Section>

            <Section title="Carta Cena"> 
                <Cartas firebaseId={"/cena"}/> 
                <HorariosCarta firebaseId={"/cena"}/>
            </Section>

            <Section title="Carta Noche"> 
                <Cartas firebaseId={"/noche"}/> 
                <HorariosCarta firebaseId={"/noche"}/>
            </Section>

            <Section title="Carta Madrugada"> 
                <Cartas firebaseId={"/madrugada"}/> 
                <HorariosCarta firebaseId={"/madrugada"}/>
            </Section>

            <Section title="Popups"> <Popups/> </Section>
            
            <Section title="Novedades"> <EditorFotos Path="/Novedades"/> </Section>
            <Section title="Promos"> <EditorFotos Path="/Promos"/> </Section>
            <Section title="Merchandasing"> <EditorFotos Path="/Merchandasing"/> </Section>
        </div>
    )
}

export default Configuracion
